var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    fill: "#2255a1",
    viewBox: "0 0 432 432",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M203 0c56 0 107 23 144 60 36 36 59 87 59 143s-23 107-59 144c-37 36-88 59-144 59S96 383 60 347C23 310 0 259 0 203S23 96 60 60C96 23 147 0 203 0zm-57 156c0 5-4 8-8 8-5 0-8-3-8-8 0-20 8-39 21-52s32-22 52-22c21 0 39 9 52 22 14 13 22 32 22 52s-8 39-22 52c-11 12-27 19-44 21v36c0 5-3 8-8 8-4 0-8-3-8-8v-43c0-5 4-8 8-8 16 0 31-7 41-17 10-11 17-25 17-41s-7-30-17-41c-10-10-25-16-41-16s-30 6-40 16c-11 11-17 25-17 41zm49 157c0-5 4-8 8-8 5 0 8 3 8 8v3c0 4-3 8-8 8-4 0-8-4-8-8v-3zm8-297c-51 0-98 21-132 55s-55 81-55 132c0 52 21 98 55 132s81 55 132 55c52 0 98-21 132-55s55-80 55-132c0-51-21-98-55-132s-80-55-132-55z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/Help.349e324c021c83726b4e68d7c73220e1.svg";
export { ForwardRef as ReactComponent };